export const getActiveTab = (state) => state?.app?.tabID;
export const getModalState = (state) => state?.app?.modalState;
export const getFailedPayment = (state) => state?.app?.failedPayment;
export const getExamStatus = (state) => state?.app?.exam_Status;
export const getLandedUrl = (state) => state?.app?.landed_url;
export const getIsAlertOpen = (state) => state?.app?.isAlertOpen;
